/**
 * Task 10.21 — whether a wine was good enough to buy again.
 *
 * The rule is the decision of 2026-09-26 in `project-scope.md`: the cellar's
 * own rating decides, the other sources only where it is silent, and *good*
 * is four fifths of each scale's top. Whether anything of the wine is left is
 * not asked here — that is the stock narrowing's question, and `wine-filter.ts`
 * asks both.
 *
 * Pure and in `shared/` for the reason every narrowing of the list is: the
 * list is filtered in the browser over rows it already holds, and the rows
 * already carry each source's latest reading with its scale and whether it is
 * the cellar's own. No field was added for this.
 */
/**
 * Whether one reading is high on its own scale.
 *
 * Four fifths, inclusive, compared as `score × 5 ≥ top × 4` so that no
 * fraction is ever computed: 0,8 × 5 happens to be exactly 4 in floating
 * point, and a rule that holds by luck on the one scale the cellar has today
 * is a rule waiting for the scale that breaks it.
 */
function isHigh(rating) {
    return rating.score * 5 >= rating.scaleMax * 4;
}
/**
 * Whether these ratings say the wine was worth buying again.
 *
 * **The owner's own voice, where it has spoken, is the whole answer** — high
 * puts the wine on the list and low keeps it off, whatever Vivino thinks. Only
 * a wine the owner has not rated is judged by the others, and then any one of
 * them rating it highly is enough: the question is whether somebody whose
 * judgement the cellar keeps thought it good, not whether they all agreed.
 */
export function worthBuyingAgain(ratings) {
    const own = ratings.filter((rating) => rating.isOwn);
    return (own.length > 0 ? own : ratings).some(isHigh);
}
//# sourceMappingURL=buy-again.js.map